/**
 * Suggest Service
 */

DM.Service.Suggest = (function () {
    var controller = null;
    var URL_ENDPOINT = '/Suggester/Suggest';

    return {
        getOptions: function (query) {
            if (controller) {
                controller.abort();
            }
            controller = new AbortController();

            return fetch(URL_ENDPOINT + '?query=' + query, { signal: controller.signal }).then(response => {
                controller = null;
                return response.json();
            });
        }
    };
})();
